document.addEventListener('DOMContentLoaded', function () {

// ---- MAIN MENU TOGGLE ----
const btn = document.getElementById('mobile_menu');
const nav = document.getElementById('top_nav');
const iconHamburger = document.getElementById('icon_hamburger');
const iconClose = document.getElementById('icon_close');

if (btn && nav) {
  btn.addEventListener('click', function () {

    nav.classList.toggle('hidden');

    if (iconHamburger) {
      iconHamburger.classList.toggle('hidden');
    }

    if (iconClose) {
      iconClose.classList.toggle('hidden');
    }

  });
}


// ---- SUB MENU ----
document.querySelectorAll('.submenu_icon').forEach(function (subMenuButton) {

  subMenuButton.addEventListener('click', function (event) {

    event.preventDefault();
    event.stopPropagation();

    if (window.innerWidth >= 1024) {
      return;
    }

    var parentItem = subMenuButton.closest('li');

    if (!parentItem) {
      return;
    }

    var subMenu =
      parentItem.querySelector(':scope > .sub_menu') ||
      parentItem.querySelector(':scope > .mega-menu');

    if (!subMenu) {
      return;
    }

    var isHidden = subMenu.classList.contains('hidden');

    if (isHidden) {

      // Open submenu
      subMenu.classList.remove('hidden');

      requestAnimationFrame(function () {
        subMenu.classList.remove('opacity-0');
        subMenu.classList.add('opacity-100');
      });

      // Rotate icon
      subMenuButton.classList.add('rotate-180');

    } else {

      // Close submenu
      subMenu.classList.remove('opacity-100');
      subMenu.classList.add('opacity-0');

      // Reset icon
      subMenuButton.classList.remove('rotate-180');

      setTimeout(function () {
        subMenu.classList.add('hidden');
      }, 300);

    }

  });

});


// ---- MEGA MENU SUBMENU ----
document.querySelectorAll('.mega-submenu-toggle').forEach(function (toggle) {

  toggle.addEventListener('click', function (event) {

    event.preventDefault();
    event.stopPropagation();

    if (window.innerWidth >= 1024) {
      return;
    }

    var column = toggle.closest('.mega-menu-column');

    if (!column) {
      return;
    }

    var isOpen = column.classList.contains('is-open');

    if (isOpen) {

      column.classList.remove('is-open');
      toggle.classList.remove('rotate-180');
      toggle.setAttribute('aria-expanded', 'false');

    } else {

      column.classList.add('is-open');
      toggle.classList.add('rotate-180');
      toggle.setAttribute('aria-expanded', 'true');

    }

  });

});

  // ---- SEARCH TOGGLE ----
  let searchButton = document.querySelector(".search-button");
  let searchContainer = document.querySelector(".search_container");  

  searchButton.addEventListener("click", function () {
    let isHidden = searchContainer.classList.contains("opacity-0");

    if (isHidden) {
      searchContainer.classList.remove("opacity-0", "scale-95", "pointer-events-none");
      searchContainer.classList.add("opacity-100", "scale-100");
    } else {
      searchContainer.classList.remove("opacity-100", "scale-100");
      searchContainer.classList.add("opacity-0", "scale-95", "pointer-events-none");
    }
  });

// ---- MULTI TAB ----
function initPrimaryMultiTab() {
  document.querySelectorAll('.primary_multi_tab').forEach(function (tabContainer) {
    var tabButtons = tabContainer.querySelectorAll('[data-tab]');
    var tabContents = tabContainer.querySelectorAll('[data-tab-content]');

    if (!tabButtons.length || !tabContents.length) return;

    function activateTab(tabName) {
      tabButtons.forEach(function (button) {
        var isActive = button.dataset.tab === tabName;

        
    button.classList.toggle('text-primary', isActive);
    button.classList.toggle('border-primary', isActive);
    button.classList.toggle('bg-white', isActive);

    button.classList.toggle('text-gray-500', !isActive);
    button.classList.toggle('border-transparent', !isActive);
    button.classList.toggle('bg-transparent', !isActive);
      });

      tabContents.forEach(function (content) {
        var isActive = content.dataset.tabContent === tabName;

        content.classList.toggle('hidden', !isActive);
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(this.dataset.tab);
      });
    });

    // C1 active by default
    activateTab('front-c1');
  });
}

// Run after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPrimaryMultiTab);
} else {
  initPrimaryMultiTab();
}

  // --- FIRST SPLIDE ELEMENT ---
  if (document.getElementById('one_slide')) {
    new Splide('#one_slide', {
      type: 'loop',
      perPage: 1,
      pagination: false,
      gap: '1rem',
      focus: 'center',
      autoplay: true,
      interval: 10000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,
    }).mount();
  }
  // --- FIRST SPLIDE ELEMENT ---

  // --- SECOND SPLIDE ELEMENT ---
  if (document.getElementById('second_slide')) {
    new Splide('#second_slide', {
      type: 'loop',
      perPage: 1,
      pagination: true,
      gap: '1rem',
      focus: 'center',
      autoplay: true,
      interval: 6000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: false,
    }).mount();
  }
  // --- SECOND SPLIDE ELEMENT ---
  
  // --- THIRD SPLIDE ELEMENT ---
  if (document.getElementById('third_slide')) {
    new Splide('#third_slide', {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      focus: 'left',
      pagination: false,
      gap: '1rem',
      autoplay: true,
      interval: 6000,
      direction: 'rtl',
      arrows: true,
      trimSpace: false,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    }).mount();
  }
  // --- THIRD SPLIDE ELEMENT ---

  // --- FORTH SPLIDE ELEMENT ---
  if (document.getElementById('forth_slide')) {
    new Splide('#forth_slide', {
      type: 'loop',
      perPage: 1,
      pagination: false,
      gap: '1rem',
      focus: 'center',
      autoplay: true,
      interval: 6000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,
    }).mount();
  }
  // --- FORTH SPLIDE ELEMENT ---

  // --- FIFTH SPLIDE ELEMENT ---
  if (document.getElementById('fifth_slide')) {
    new Splide('#fifth_slide', {
      type: 'loop',
      perPage: 4,
      pagination: false,
      gap: '1rem',
      autoplay: true,
      interval: 6000,
      wheel: true, //
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,

      breakpoints: {
        768: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
      },
    }).mount();
  }
  // --- FIFTH SPLIDE ELEMENT ---

  // --- SIXTH SPLIDE ELEMENT ---
  if (document.getElementById('sixth_slide')) {
    new Splide('#sixth_slide', {
      type: 'loop',
      perPage: 4,
      pagination: false,
      gap: '1rem',
      autoplay: true,
      interval: 6000,
      wheel: true, //
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,

      breakpoints: {
        768: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
      },
    }).mount();
  }
  // --- SIXTH SPLIDE ELEMENT ---

  // --- SEVENTH SPLIDE ELEMENT ---
  if (document.getElementById('seventh_slide')) {
    new Splide('#seventh_slide', {
      type: 'loop',
      perPage: 4,
      pagination: false,
      gap: '1rem',
      autoplay: true,
      interval: 6000,
      wheel: true, //
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,

      breakpoints: {
        768: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
      },
    }).mount();
  }
  // --- SEVENTH SPLIDE ELEMENT ---

  // ---- START OF TABs ----
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("block");
            contents[i].classList.remove("hidden");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("block");
            contents[i].classList.add("hidden");
          }
        });
      });
    });
  }

  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
  });
  // ---- END OF TABs ----

  // ---- ARCHIVE TOGGLE ----
  const flip = document.querySelector(".flip");
  const flip2 = document.querySelector(".flip2");
  const content = document.querySelector(".content-wrapper");
  const content2 = document.querySelector(".content-wrapper2");

  if (flip) {
    flip.addEventListener("click", () => {
      if (content.style.maxHeight && content.style.maxHeight !== "0px") {
        content.style.maxHeight = "0px";
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }  
  if (flip2) {
    flip2.addEventListener("click", () => {
      if (content2.style.maxHeight && content2.style.maxHeight !== "0px") {
        content2.style.maxHeight = "0px";
      } else {
        content2.style.maxHeight = content2.scrollHeight + "px";
      }
    });
  }
})

document.addEventListener('DOMContentLoaded', function () {
  // Select all headers, bodies, and arrows
  var headers   = document.querySelectorAll('[id^="header-"]');
  var allBodies = document.querySelectorAll('[id^="body-"]');
  var allArrows = document.querySelectorAll('[id^="arrow-"]');

  // Close all sections on page load
  allBodies.forEach(function (b) {
    b.style.maxHeight = '0px';
  });

  // Reset all arrows rotation
  allArrows.forEach(function (a) {
    a.style.transform = 'rotate(0deg)';
  });

  // Store original header colors
  headers.forEach(function (h) {
    h.dataset.originalBg = h.style.backgroundColor || '';
    h.dataset.originalText = h.style.color || '';
  });

  // Open last item by default
  var lastIndex = allBodies.length - 1;

  var lastBody  = document.getElementById('body-' + lastIndex);
  var lastArrow = document.getElementById('arrow-' + lastIndex);
  var lastHeader = document.getElementById('header-' + lastIndex);

  if (lastBody) {
    lastBody.style.maxHeight = lastBody.scrollHeight + 'px';
    lastArrow.style.transform = 'rotate(180deg)';

    // Set active header color (blue)
    if (lastHeader) {
      lastHeader.style.backgroundColor = '#3b2f8f'; // Tailwind blue-600
      lastHeader.style.color = '#fff'; // Tailwind blue-600
    }
  }

  // Click handler for accordion
  headers.forEach(function (header) {
    header.addEventListener('click', function () {

      var index = header.id.replace('header-', '');

      var clickedBody  = document.getElementById('body-' + index);
      var clickedArrow = document.getElementById('arrow-' + index);

      var isOpen = clickedBody.style.maxHeight !== '0px';

      // Close all sections
      allBodies.forEach(function (b) {
        b.style.maxHeight = '0px';
      });

      // Reset all arrows
      allArrows.forEach(function (a) {
        a.style.transform = 'rotate(0deg)';
      });

      // Restore all headers to original color
      headers.forEach(function (h) {
        h.style.backgroundColor = h.dataset.originalBg;
        h.style.color = h.dataset.originalText;
      });

      // If the clicked one was closed, open it
      if (!isOpen) {
        clickedBody.style.maxHeight = clickedBody.scrollHeight + 'px';
        clickedArrow.style.transform = 'rotate(180deg)';

        // Set active header color (blue)
        header.style.backgroundColor = '#3b2f8f';
        header.style.color = '#fff';
      }
    });
  });
    // ---- START OF light Gallery ----
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true,
        direction: 'ltr',
      });
    });
  }
  // ---- END OF light Gallery ----
});